import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../../features/auth/services/auth.service';

export const guestGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return authService.currentUser()?.mustChangePassword
      ? router.createUrlTree(['/change-password'])
      : router.createUrlTree(['/app/home']);
  }

  return true;
};
